import { useState, useEffect } from "react";

export function Typewriter({ words, className = "", speed = 85, pause = 1400 }) {
  const [i, setI] = useState(0);
  const [txt, setTxt] = useState("");
  const [del, setDel] = useState(false);

  useEffect(() => {
    const word = words[i % words.length];
    let t;
    if (!del && txt.length < word.length) {
      t = setTimeout(() => setTxt(word.slice(0, txt.length + 1)), speed);
    } else if (!del && txt.length === word.length) {
      t = setTimeout(() => setDel(true), pause);
    } else if (del && txt.length > 0) {
      t = setTimeout(() => setTxt(word.slice(0, txt.length - 1)), speed / 2);
    } else {
      setDel(false);
      setI((v) => v + 1);
    }
    return () => clearTimeout(t);
  }, [txt, del, i, words, speed, pause]);

  return (
    <span className={className}>
      {txt}
      <span className="animate-pulse" style={{ marginLeft: 1 }}>▋</span>
    </span>
  );
}
